module.exports = __webpack_public_path__ + "static/media/trophie-winner.c01bb0bd.png";